import { Monitor, Moon, Sun } from "lucide-react"
import { useTheme } from "next-themes"
import { cn } from "@/lib/utils"
import { t } from "@/lib/i18n"

const THEME_OPTIONS = [
  { value: "light", labelKey: "theme_light", icon: Sun },
  { value: "dark", labelKey: "theme_dark", icon: Moon },
  { value: "system", labelKey: "theme_system", icon: Monitor },
] as const

export function ThemeSelector() {
  const { theme, setTheme } = useTheme()
  const current = theme ?? "system"

  return (
    <section className="space-y-2" data-testid="theme-selector">
      <h2 className="text-sm font-semibold tracking-tight">
        {t("ui.react.components.features.profiles.settings.appearance")}
      </h2>
      <div className="grid grid-cols-3 gap-2">
        {THEME_OPTIONS.map((option) => {
          const active = current === option.value
          const Icon = option.icon
          return (
            <button
              key={option.value}
              type="button"
              onClick={() => setTheme(option.value)}
              data-testid={`theme-option-${option.value}`}
              data-active={active ? "true" : "false"}
              className={cn(
                "flex flex-col items-center gap-1.5 rounded-xl border p-3 text-sm font-medium transition-colors",
                active ? "border-primary bg-primary/5" : "border-border hover:bg-muted/50"
              )}
            >
              <Icon className={cn("size-4", active ? "text-primary" : "text-muted-foreground")} />
              {t(`ui.react.components.features.profiles.settings.${option.labelKey}`)}
            </button>
          )
        })}
      </div>
    </section>
  )
}
